import React from 'react';
import HomeHeader from './components/HomeHeader';

function App() {
  return <HomeHeader />;
}

export default App;
